export default "__VITE_ASSET__87fc9348__"